module.exports = __webpack_public_path__ + "img/77ade073-0f18-4833-af5c-ecc1fee8884d.4369447b.png";